import React from 'react';
import PropTypes from 'prop-types';

import SponsorImage from './SponsorImage';

import AbsoluteAsset from '../AbsoluteAsset';

import './sponsors.scss';

const getSponsorsForTier = (sponsorList, tier) => (
  <div className={`sponsors__list sponsors__${tier}`}>
    {
      sponsorList
        .filter(s => s.sponsor_object.tier === tier)
        .map(({ sponsor_object: s }) =>
        (<SponsorImage
          link={s.link}
          image={s.image}
          alt={s.alt}
          tier={s.tier}
          key={s.image}
          paddingTop={`${s.padding}px`}
          paddingBottom={`${s.padding}px`}
        />))
    }
  </div>
);

const Sponsors = ({ data }) => (
  <div className="container abs-asset-holder sponsors">
    <div id="Sponsors" />
    <div className="">
      <h1 className="sponsors__subheading">{data.sponsor_list_heading}</h1>
      { getSponsorsForTier(data.sponsor_list, 'gold') }
      { getSponsorsForTier(data.sponsor_list, 'silver') }
      { getSponsorsForTier(data.sponsor_list, 'bronze') }
      { getSponsorsForTier(data.sponsor_list, 'startup')}
      <h2 className="sponsors__subheading">{data.partner_list_heading}</h2>
      { getSponsorsForTier(data.sponsor_list, 'partner')}
    </div>
    <AbsoluteAsset className="e52 e52--sponsor" src="/assets/e52.png" />
    <AbsoluteAsset className="e53 e53--sponsor" src="/assets/e53.png" />
  </div>
);

Sponsors.propTypes = {
  data: PropTypes.shape({
    sponsor_us: PropTypes.string,
    sponsor_list: PropTypes.arrayOf(PropTypes.shape({
      sponsor_object: PropTypes.shape({
        link: PropTypes.string.isRequired,
        image: PropTypes.string.isRequired,
        tier: PropTypes.string.isRequired,
      }),
    })),
    sponsor_list_heading: PropTypes.string.isRequired,
    partner_list_heading: PropTypes.string.isRequired,
  }).isRequired,
};

export default Sponsors;



// WEBPACK FOOTER //
// ./src/components/Sponsors/index.jsx